import { DeliveryOrderConfig } from '@core/models/delivery/delivery-order-config';
import { DeliveryOrdersFilters } from '@core/models/delivery/filters/delivery-orders-filters';
import { IListState, initialListState } from '../shared/list/list.state';
import { DeliveryOrderQuote } from '@core/models/delivery/quote/delivery-order-quote';
import { CreateDeliveryOrderRequest } from '@core/models/delivery/create-delivery-order-request';
import { ListSortBy } from '@core/models/common/list-sort-by';
import { DeliveryOrdersSummary } from '@core/models/delivery/summary/delivery-orders-summary';
import { DeliveryOrderGroupTracking } from '@core/models/delivery/tracking/delivery-order-group-tracking';
import { initialDeliveryOrdersFiltersState } from './filters/deliveries-filters.state';
import { DeliveryIntegration } from '@core/models/delivery/integrations/delivery-integration';

export interface IDeliveriesState {
    orders: IListState;
    summary: DeliveryOrdersSummary;
    filters: DeliveryOrdersFilters;
    viewedOrderId: string;
    viewedDeliveryIngrationId: string;
    configs: { [locationId: string]: DeliveryOrderConfig };
    integrations: { [provider: string]: DeliveryIntegration };
    tracking: DeliveryOrderGroupTracking;
    quotes: {
        [id: string]: DeliveryOrderQuote[];
    };
    isFetchingIntegrations: boolean;
    isFetchingQuotes: boolean;
    isFetchingDeliveryConfig: boolean;
    isFetchingDispatchConfig: boolean;
    isFetchingOrder: boolean;
    isOrderOnFocus: boolean;
    newOrder: CreateDeliveryOrderRequest;
}

export function initialDeliveriesState(): IDeliveriesState {
    return {
        orders: {
            ...initialListState,
            filterBy: initialDeliveryOrdersFiltersState,
            sortBy: ListSortBy.STATUS_TIME_TYPE,
        },
        summary: null,
        filters: null,
        viewedOrderId: null,
        viewedDeliveryIngrationId: null,
        configs: {},
        integrations: {},
        tracking: null,
        quotes: {},
        isFetchingIntegrations: false,
        isFetchingQuotes: false,
        isFetchingDeliveryConfig: false,
        isFetchingDispatchConfig: false,
        isOrderOnFocus: false,
        isFetchingOrder: false,
        newOrder: null,
    }
}